import {SOCKET_URL, PLATFORM_ID} from 'constants/index';
import io from 'socket.io-client';

const socket = io(SOCKET_URL, {
  transports: ['websocket', 'polling'],
});

export default class SocketService {
  private static socket: any;

  static setupSocket() {
    this.socket = socket;
  }

  static getSocket() {
    return this.socket;
  }

  /**
   * Add socket event listener
   * @param {string} event
   * @param {function} callback
   */
  static on(event: string, callback?: (params: any) => any) {
    this.socket?.on(event, callback);
  }

  /**
   * Remove a socket event listener
   * @param {string} event
   */
  static off(event: string) {
    this.socket?.off(event);
  }

  /**
   * Emit socket event
   * @param {string} event
   * @param {any} data
   */
  static emit(event: string, data?: any) {
    this.socket?.emit(event, data);
  }

  static setOnline(token: string) {
    if (this.socket) {
      this.emit('onlineUser', {token, channel: PLATFORM_ID});
      this.on('connect', () => {
        console.log('Socket connected');
        console.log(this.socket);
        this.emit('onlineUser', {token, channel: PLATFORM_ID});
      });
    }
  }
}
